import {
    NotificationsData,
    PasswordData,
} from '../../Pages/UserSettingsPage/UserSettings'
import { User } from '../../Redux/Admin_Tasks/userAccountSlice';
import { getBaseQuery,  getBaseUrl } from '../../Utils'
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react'

const baseUrl = `${getBaseUrl()}/API/v3`;
interface UserSettingsState {
    loading: boolean;
    successMessage?: string;
    errorMessage?: string;
}

const initialState: UserSettingsState = {
    loading: false,
    successMessage: undefined,
    errorMessage: undefined,
};

const userSettingsSlice = createSlice({
    name: 'userSettings',
    initialState,
    reducers: {
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setSuccessMessage: (state, action: PayloadAction<string | undefined>) => {
            state.successMessage = action.payload;
        },
        setErrorMessage: (state, action: PayloadAction<string | undefined>) => {
            state.errorMessage = action.payload;
        },
    },
});

export const userSettings = createApi({
    reducerPath: 'userSettings',
    baseQuery: getBaseQuery(baseUrl),
    endpoints: (builder) => ({
        SaveGeneralSettings: builder.mutation<any,  Partial<User>>({
            query: (generalData) => ({
                url: '/Account/me/generalSettings',
                method: 'PUT',
                body: generalData,
            }),
        }),

        SavePasswordSettings: builder.mutation<any, PasswordData>({
            query: (passwordData) => ({
                url: '/Account/me/password',
                method: 'PUT',
                body: passwordData,
            }),
        }),

        SaveNotificationSettings: builder.mutation<any, NotificationsData>({
            query: (notificationData) => ({
                url: '/Account/me/notifications',
                method: 'PUT',
                body: notificationData,
            }),
        }),
        GetUsersList: builder.mutation<any, any>({
            query: (reqUsers) => ({
                url: '/Proxy/FilteredUsers_Proxy',
                method: 'POST',
                body:reqUsers
            }),
            transformResponse: (response: any) => {
                return response.data ? response.data.proxyUserList : []
            },
        }),
        ProxyUser: builder.mutation<any, any>({
            query: (proxyUserId) => ({
                url: '/Proxy/SwitchToProxyUser',
                method: 'POST',
                body:proxyUserId
            }),
        }),
        ExitProxy: builder.mutation<any, any>({
            query: (proxyUserId) => ({
                url: '/Proxy/ExitProxyUser',
                method: 'POST',
                body:proxyUserId
            }),
        }),
    }),
})

// Export the hooks for the API endpoints
export const {
    useSaveGeneralSettingsMutation,
    useSavePasswordSettingsMutation,
    useSaveNotificationSettingsMutation,
    useGetUsersListMutation,
    useProxyUserMutation,
    useExitProxyMutation
} = userSettings

// export const { setLoading, setSuccessMessage, setErrorMessage } = userSettingsSlice.actions;

// export default userSettingsSlice.reducer;